import React from 'react';
import PropTypes from 'prop-types';
import { compose, withStateHandlers, withPropsOnChange, lifecycle } from 'recompose';
import classnames from 'classnames';

import CustomOverlayComponent from 'components/core/library/mapV2/customOverlayComponent';
import { Text } from 'components/core/Text';
import withViewportWidth from 'decorators/withViewportWidth';
import FacilityInfoWindow from './FacilityInfoWindow';

export const enhance = compose(
	withViewportWidth,
	withStateHandlers({
		active: false,
		infoWindowOpen: false
	}, {
		setActive: (_, { zIndex: propZIndex }) => (active) => ({ active, zIndex: active ? 2000 : propZIndex }),
		handleMarkerClick: ({ infoWindowOpen }) => () => {
			return { infoWindowOpen: !infoWindowOpen, zIndex: 2000 };
		},
		handlePageClick: () => () => ({ infoWindowOpen: false })
	}),
	withPropsOnChange(['highlighted'], (props) => {
		if (props.active !== !!props.highlighted) {
			props.setActive(!!props.highlighted);
		}
	}),
	withPropsOnChange(['facility'], ({ facility }) => {
		if (facility.cheapestPrice && facility.cheapestPrice.text) {
			return { label: `$${facility.cheapestPrice.text.split('.')[0]}` };
		}

		const cheapestUnitPrice = facility.units.reduce(
			(min, unit) => (
				parseInt(unit.price?.text) < parseInt(min) ?
					unit.price?.text :
					min
			), facility.units[0].price?.text
		);

		return { label: `$${cheapestUnitPrice?.split('.')[0]}` };
	}),
	lifecycle({
		componentDidMount() {
			const { isPreselectedFacility, handleMarkerClick } = this.props;
			if (isPreselectedFacility) {
				handleMarkerClick();
			}
		},
		componentWillUnmount() {
			this.props.handlePageClick();
		}
	})
);

export function FacilityMarker({
	position, label, setActive, active, zIndex, facility, handleMarkerClick, infoWindowOpen, handlePageClick,
	phone, viewportWidth, getLocalPhoneNumberByZipCode
}) {
	return (
		<div>
			<CustomOverlayComponent
				position={position}
				zIndex={zIndex}
			>
				<button
					className={classnames('facility-marker-icon', { active, hidden: infoWindowOpen })}
					onMouseEnter={() => setActive(true)}
					onMouseOut={() => setActive(false)}
					onBlur={() => setActive(false)}
					onClick={handleMarkerClick}
					type="button"
				>
					<Text className="marker-label">{label}</Text>
				</button>
			</CustomOverlayComponent>
			{!!infoWindowOpen &&
				<FacilityInfoWindow
					idleDisabled
					viewportWidth={viewportWidth}
					position={position}
					facility={facility}
					onClickOutside={handlePageClick}
					phone={phone}
					getLocalPhoneNumberByZipCode={getLocalPhoneNumberByZipCode}
				/>
			}
		</div>
	);
}

FacilityMarker.propTypes = {
	position: PropTypes.shape({ lat: PropTypes.number, lng: PropTypes.number }),
	label: PropTypes.string,
	setActive: PropTypes.func,
	active: PropTypes.bool,
	zIndex: PropTypes.number,
	facility: PropTypes.object,
	handleMarkerClick: PropTypes.func,
	infoWindowOpen: PropTypes.bool,
	handlePageClick: PropTypes.func,
	phone: PropTypes.object,
	getLocalPhoneNumberByZipCode: PropTypes.func,
	viewportWidth: PropTypes.number
};

export default enhance(FacilityMarker);
